import { card } from 'services/graphql/fragments/Fragments';
import { gql } from 'urql';

const FetchCardUser = gql`
  query FetchCardUser($cardId: ID!) {
    card(id: $cardId) {
      ...card
    }
    cardNumber(input: { cardId: $cardId }) {
      __typename
      ... on CardNumberSuccess {
        expiration
      }
    }
    user {
      id
      customerInfo {
        id
        name {
          first
          last
          full
        }
      }
    }
  }
  ${card}
`;

export default FetchCardUser;
